// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"21":"48d36d6e","112":"7106fd3d","397":"c7e25e21","453":"e3996d25","687":"acb084fc","876":"2dcbf9fb"}[chunkId] + ".chunk.js";
};